import React, { useState, useEffect } from 'react';
import {object, func, bool, string} from 'prop-types';

import {CloneObject} from '../../../utils/helpers';
import {isValidNumber} from '../../../utils/validator';
import { ALERT_TYPE, ShowToastMessage, useForm } from '@laramie/ui';
import {VALIDATION_MESSAGE} from '../../../consts/validationMessage';
import {useFormErrors} from '../../hooks/useFormErrors';
import InputLista from '../../common/InputLista';
import DataTaggerFormRedux from '../DataTaggerFormRedux';
import InputNumber from '../../common/InputNumber';
import InputPercent from '../../common/InputPercent';
import {TIPS} from "../../../consts/tips";
import {Accordion, CheckboxButton, CheckboxButtonGroup, FormError, FormLabel, Modal} from '../../common';

const EdesurModal = (props) => {

    const entityInit = {
        id: 0,
        idInmueble: 0,
        ultPeriodoEdesur: "",
        ultCuotaEdesur: "",
        ultImporteEdesur: 0,
        medidor: "",
        idFrecuenciaFacturacion: 0,
        plan: "",
        radio: "",
        manzana: "",
        idAnteriorEdesur: "",
        tarifa: 0,
        tarifa1: 0,
        claseServicio: "",
        porcDesc: 0,
        cAnual: "",
        recorrido: "",
        planB: "",
        lzEdesur: false,
        facturarABL: false,
        facturar: false,
        facturarEdesur: false,
        comuna: "",
        calleEdesur: "",
        numeroEdesur: ""
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit,
    });

    const mount = () => {
        setState(prevState => {
            return {...prevState, entity: props.data.entity};
        });
        formSet({
            ultPeriodoEdesur: props.data.entity.ultPeriodoEdesur,
            ultCuotaEdesur: props.data.entity.ultCuotaEdesur,
            ultImporteEdesur: props.data.entity.ultImporteEdesur,
            medidor: props.data.entity.medidor,
            idFrecuenciaFacturacion: props.data.entity.idFrecuenciaFacturacion,
            plan: props.data.entity.plan,
            radio: props.data.entity.radio,
            manzana: props.data.entity.manzana,
            idAnteriorEdesur: props.data.entity.idAnteriorEdesur,
            tarifa: props.data.entity.tarifa,
            tarifa1: props.data.entity.tarifa1,
            claseServicio: props.data.entity.claseServicio,
            porcDesc: props.data.entity.porcDesc,
            cAnual: props.data.entity.cAnual,
            recorrido: props.data.entity.recorrido,
            planB: props.data.entity.planB,
            lzEdesur: props.data.entity.lzEdesur,
            facturarABL: props.data.entity.facturarABL,
            facturar: props.data.entity.facturar,
            facturarEdesur: props.data.entity.facturarEdesur,
            comuna: props.data.entity.comuna,
            calleEdesur: props.data.entity.calleEdesur,
            numeroEdesur: props.data.entity.numeroEdesur
        });
    }
    useEffect(mount, [props.data.entity]);

    const [formValues, formHandle, , formSet] = useForm({
        ultPeriodoEdesur: "",
        ultCuotaEdesur: "",
        ultImporteEdesur: 0,
        medidor: "",
        idFrecuenciaFacturacion: 0,
        plan: "",
        radio: "",
        manzana: "",
        idAnteriorEdesur: "",
        tarifa: 0,
        tarifa1: 0,
        claseServicio: "",
        porcDesc: 0,
        cAnual: "",
        recorrido: "",
        planB: "",
        lzEdesur: false,
        facturarABL: false,
        facturar: false,
        facturarEdesur: false,
        comuna: "",
        calleEdesur: "",
        numeroEdesur: ""
    });

    // Handlers

    const { errorOf, validate } = useFormErrors(getErrors);

    const handleClickAceptar = () => {
        if (!validate()) return;

        let row = CloneObject(state.entity);
        row.ultPeriodoEdesur = formValues.ultPeriodoEdesur;
        row.ultCuotaEdesur = formValues.ultCuotaEdesur;
        row.ultImporteEdesur = formValues.ultImporteEdesur;
        row.medidor = formValues.medidor;
        row.idFrecuenciaFacturacion = parseInt(formValues.idFrecuenciaFacturacion);
        row.plan = formValues.plan;
        row.radio = formValues.radio;
        row.manzana = formValues.manzana;
        row.idAnteriorEdesur = formValues.idAnteriorEdesur;
        row.tarifa = formValues.tarifa;
        row.tarifa1 = formValues.tarifa1;
        row.claseServicio = formValues.claseServicio;
        row.porcDesc = formValues.porcDesc;
        row.cAnual = formValues.cAnual;
        row.recorrido = formValues.recorrido;
        row.planB = formValues.planB;
        row.lzEdesur = formValues.lzEdesur;
        row.facturarABL = formValues.facturarABL;
        row.facturar = formValues.facturar;
        row.facturarEdesur = formValues.facturarEdesur;
        row.comuna = formValues.comuna;
        row.calleEdesur = formValues.calleEdesur;
        row.numeroEdesur = formValues.numeroEdesur;

        props.onConfirm(row);
    };

    // Funciones
    function getErrors() {

        const errors = {};

        if (formValues.medidor.length <= 0) errors.medidor = VALIDATION_MESSAGE.REQUIRED;
        if (formValues.idFrecuenciaFacturacion <= 0) errors.idFrecuenciaFacturacion = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (!isValidNumber(formValues.ultImporteEdesur, false)) errors.ultImporteEdesur = VALIDATION_MESSAGE.REQUIRED_SHORT;
        if (!isValidNumber(formValues.tarifa, false)) errors.tarifa = VALIDATION_MESSAGE.REQUIRED_SHORT;
        if (!isValidNumber(formValues.tarifa1, false)) errors.tarifa1 = VALIDATION_MESSAGE.REQUIRED_SHORT;
        if (!isValidNumber(formValues.porcDesc, false)) errors.porcDesc = VALIDATION_MESSAGE.REQUIRED_SHORT;

        return errors;
    }

    return (
            <Modal
                size="lg"
                title={`Cliente: ${(state.entity.id > 0) ? `N° Medidor: ${state.entity.medidor}` : "Nuevo"}`}
                tipName={TIPS.NAME.MODALS.EDESUR_CLIENTE_MODAL}
                onEscape={() => props.onDismiss()}
                body={(
                            <div className="row">
                                <div className="mb-3 col-12">
                                    <Accordion title="Última factura" startOpen={true}>
                                        <div className='row form-basic'>
                                            <div className="mb-3 col-6 col-lg-2">
                                                <label htmlFor="ultPeriodoEdesur"
                                                       className="form-label">Período</label>
                                                <input
                                                    name="ultPeriodoEdesur"
                                                    type="text"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.ultPeriodoEdesur}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError />
                                            </div>
                                            <div className="mb-3 col-6 col-lg-2">
                                                <label htmlFor="ultCuotaEdesur" className="form-label">Cuota</label>
                                                <input
                                                    name="ultCuotaEdesur"
                                                    type="text"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.ultCuotaEdesur}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError />
                                            </div>
                                            <div className="mb-3 col-6 col-lg-2">
                                                <FormLabel htmlFor="ultImporteEdesur" required>Importe
                                                   </FormLabel>
                                                <InputNumber
                                                    name="ultImporteEdesur"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('ultImporteEdesur') ? 'is-invalid' : ''}`}
                                                    value={formValues.ultImporteEdesur}
                                                    precision={2}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('ultImporteEdesur')} />
                                            </div>
                                            <div className="mb-3 col-6 col-lg-2">
                                                <FormLabel htmlFor="tarifa" required>Tarifa</FormLabel>
                                                <InputNumber
                                                    name="tarifa"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('tarifa') ? 'is-invalid' : ''}`}
                                                    value={formValues.tarifa}
                                                    precision={2}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('tarifa')} />
                                            </div>
                                            <div className="mb-3 col-6 col-lg-2">
                                                <FormLabel htmlFor="tarifa1" required>Tarifa 1</FormLabel>
                                                <InputNumber
                                                    name="tarifa1"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('tarifa1') ? 'is-invalid' : ''}`}
                                                    value={formValues.tarifa1}
                                                    precision={2}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('tarifa1')} />
                                            </div>
                                            <div className="mb-3 col-6 col-lg-2">
                                                <FormLabel htmlFor="porcDesc" required>Descuento</FormLabel>
                                                <InputPercent
                                                    name="porcDesc"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('porcDesc') ? 'is-invalid' : ''}`}
                                                    value={formValues.porcDesc}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('porcDesc')} />
                                            </div>
                                        </div>
                                        <hr className="solid m-bottom-10"></hr>
                                        <div className="row">
                                            <div className="mb-3 col-6 col-lg-3">
                                                <FormLabel htmlFor="medidor" required>Medidor</FormLabel>
                                                <input
                                                    name="medidor"
                                                    type="text"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('medidor') ? 'is-invalid' : ''}`}
                                                    value={formValues.medidor}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('medidor')} />
                                            </div>
                                            <div className="mb-3 col-6 col-lg-2">
                                                <label htmlFor="idAnteriorEdesur" className="form-label">ID
                                                    Anterior</label>
                                                <input
                                                    name="idAnteriorEdesur"
                                                    type="text"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.idAnteriorEdesur}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError />
                                            </div>
                                            <div className="mb-3 col-6 col-lg-3">
                                                <FormLabel htmlFor="idFrecuenciaFacturacion" required>Frecuencia</FormLabel>
                                                <InputLista
                                                    name="idFrecuenciaFacturacion"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idFrecuenciaFacturacion') ? 'is-invalid' : ''}`}
                                                    value={formValues.idFrecuenciaFacturacion}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    lista="FrecuenciaFacturacion"
                                                />
                                                <FormError message={errorOf('idFrecuenciaFacturacion')} />
                                            </div>
                                            <div className="mb-3 col-6 col-lg-2">
                                                <label htmlFor="plan" className="form-label">Plan</label>
                                                <input
                                                    name="plan"
                                                    type="text"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.plan}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError />
                                            </div>
                                            <div className="mb-3 col-6 col-lg-2">
                                                <label htmlFor="cAnual" className="form-label">C. Anual</label>
                                                <input
                                                    name="cAnual"
                                                    type="text"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.cAnual}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError />
                                            </div>
                                            <div className="mb-3 col-6 col-lg-2">
                                                <label htmlFor="radio" className="form-label">Radio</label>
                                                <input
                                                    name="radio"
                                                    type="text"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.radio}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                            </div>
                                            <div className="mb-3 col-6 col-lg-2">
                                                <label htmlFor="manzana" className="form-label">Manzana</label>
                                                <input
                                                    name="manzana"
                                                    type="text"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.manzana}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                            </div>
                                            {/*
                                              <div className="mb-3 col-6 col-lg-3">
                                                  <label htmlFor="idAnteriorEdesur" className="form-label">ID Anterior</label>
                                                  <input
                                                      name="idAnteriorEdesur"
                                                      type="text"
                                                      placeholder=""
                                                      className="form-control"
                                                      value={formValues.idAnteriorEdesur }
                                                      onChange={ formHandle }
                                                      disabled={props.disabled}
                                                  />
                                              </div>
                                          */}
                                            <div className="mb-3 col-6 col-lg-2">
                                                <label htmlFor="comuna" className="form-label">Comuna</label>
                                                <input
                                                    name="comuna"
                                                    type="text"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.comuna}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                            </div>
                                            <div className="mb-3 col-6 col-lg-2">
                                                <label htmlFor="numeroEdesur" className="form-label">Número</label>
                                                <input
                                                    name="numeroEdesur"
                                                    type="text"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.numeroEdesur}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                            </div>
                                            <div className="mb-3 col-6 col-lg-2">
                                                <label htmlFor="claseServicio" className="form-label">Clase
                                                    servicio</label>
                                                <input
                                                    name="claseServicio"
                                                    type="text"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.claseServicio}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                            </div>
                                            <div className="mb-3 col-6 col-lg-2">
                                                <label htmlFor="planB" className="form-label">Plan B</label>
                                                <input
                                                    name="planB"
                                                    type="text"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.planB}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                            </div>
                                            <div className="mb-3 col-6">
                                                <label htmlFor="calleEdesur" className="form-label">Calle</label>
                                                <input
                                                    name="calleEdesur"
                                                    type="text"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.calleEdesur}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                            </div>
                                            <div className="mb-3 col-6">
                                                <label htmlFor="recorrido" className="form-label">Recorrido</label>
                                                <input
                                                    name="recorrido"
                                                    type="text"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.recorrido}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="mb-3 col-12">
                                                <CheckboxButtonGroup label="Facturación">
                                                    <CheckboxButton
                                                        name="lzEdesur"
                                                        label="LZ"
                                                        checked={formValues.lzEdesur}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <CheckboxButton
                                                        name="facturarABL"
                                                        label="Facturar ABL"
                                                        checked={formValues.facturarABL}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <CheckboxButton
                                                        name="facturar"
                                                        label="Facturar"
                                                        checked={formValues.facturar}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <CheckboxButton
                                                        name="facturarEdesur"
                                                        label="Facturar servicios eléctricos"
                                                        checked={formValues.facturarEdesur}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </CheckboxButtonGroup>
                                            </div>
                                        </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Información adicional">
                                        <DataTaggerFormRedux
                                            title="Información adicional de cliente"
                                            tipName={TIPS.NAME.MODALS.INFORMACION_ADICIONAL_CLIENTE_EDESUR_MODAL}
                                            processKey={props.processKey}
                                            entidad="Edesur"
                                            idEntidad={state.entity.id}
                                            disabled={props.disabled}
                                        />
                                    </Accordion>
                                </div>
                            </div>
                )}
                footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                                <button className="btn btn-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickAceptar()}>Aceptar
                                </button>
                </>) : (
                                <button className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver
                                </button>
                )}
                footerClassName={props.disabled ? 'f-align' : ''}
            />
    );
}

EdesurModal.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

EdesurModal.defaultProps = {
    disabled: false
};

export default EdesurModal;